/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Component/TestSuiteTreeItemProvider" />
import { ISuiteTableItem } from "Test/TestPlansHubRefresh/TestHub/Component/TestSuiteTreeItemProvider.Types";
import { TestSuiteWithCount } from "Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesContract";
import { ITreeItem, TreeItemProvider } from "VSSUI/Utilities/TreeItemProvider";
import * as Utils_String from "VSS/Core/Util/String";

export class TestSuiteTreeItemDataProvider {
    constructor() {}

    public populateItems(
        suites: TestSuiteWithCount[],
        rootSuiteId: number,
        expandableStateMap: Map<number, boolean>,
        editableSuiteId: number,
        planName: string,
        isSuitesSortEnabled: boolean = false
    ): ITreeItem<ISuiteTableItem>[] {
        return this._populateItemsInternal(suites, rootSuiteId, expandableStateMap, editableSuiteId, planName, isSuitesSortEnabled);
    }

    private _sortItems(items: TestSuiteWithCount[]) {
        var diff;
        items.sort((item1: TestSuiteWithCount, item2: TestSuiteWithCount) => {
            diff = Utils_String.localeComparer(item1.name, item2.name);
            return diff;
        });
    }

    private _populateItemsInternal(
        suites: TestSuiteWithCount[],
        rootSuiteId: number,
        expandableStateMap: Map<number, boolean>,
        editableSuiteId: number,
        planName?: string,
        isSuitesSortEnabled: boolean = false
    ): ITreeItem<ISuiteTableItem>[] {
        const treeItems: ITreeItem<ISuiteTableItem>[] = [];
        const suitesLength = suites.length;

        if (isSuitesSortEnabled && suites.length > 1) {
            this._sortItems(suites);
        }

        for (let i = 0; i < suitesLength; i++) {
            const title: string = suites[i].name ? suites[i].name : (planName as string);
            const item: ISuiteTableItem = {
                title: title,
                id: suites[i].id,
                type: suites[i].suiteType,
                hasParent: suites[i].id === rootSuiteId ? false : true,
                isInEditMode: editableSuiteId === suites[i].id ? true : false,
                pointCount: suites[i].pointCount,
                totalPointCount: suites[i].totalPointCount,
                testCaseCount: suites[i].testCaseCount,
                totalTestCaseCount: suites[i].totalTestCaseCount,
                requirementId: suites[i].requirementId
            };
            let expanded = false;
            if (expandableStateMap.get(suites[i].id)) {
                expanded = true;
            }
            let childItems: ITreeItem<ISuiteTableItem>[] | undefined = undefined;
            if (suites[i].children && suites[i].children.length > 0) {
                childItems = this._populateItemsInternal(
                    suites[i].children,
                    rootSuiteId,
                    expandableStateMap,
                    editableSuiteId,
                    undefined,
                    isSuitesSortEnabled
                );
            }

            treeItems.push({
                childItems: childItems,
                data: item,
                expanded: expanded
            });
        }
        return treeItems;
    }
}

export class TestSuiteTreeItemProvider extends TreeItemProvider<ISuiteTableItem> {
    constructor(items: ITreeItem<ISuiteTableItem>[]) {
        super(items);
    }
}
